import styled from 'styled-components';
import { typeStyleMap, typeStyleSkeletonMap, } from './fixtures';
export const StyledTypeStyle = styled.div `
  ${o => typeStyleMap[o.$styleName]};
  ${o => o.$textTransform && `text-transform: ${o.$textTransform}`};
  color: ${o => o.$color === 'tertiary'
    ? o.theme.color.text.tertiary.on.background
    : o.$color === 'secondary'
        ? o.theme.color.text.secondary.on.background
        : o.$color === 'primary'
            ? o.theme.color.text.primary.on.background
            : o.$color === 'high-contrast'
                ? o.theme.color.text.highContrast.on.subtle
                : o.$color === 'critical'
                    ? o.theme.color.text.critical.on.background
                    : 'inherit'};
`;
export const StyledTypeSkeletonStyle = styled.div `
  ${o => typeStyleSkeletonMap[o.$styleName]};
  width: ${o => o.$width}px;
  width: clamp(4px, ${o => o.$width}px, 100%);
`;
//# sourceMappingURL=styles.js.map